module.exports = __webpack_public_path__ + "img/h5.7f3d13a0.png";